export class FileRequestForm {
  postalCode: Array<string> = new Array<string>();
  directionCode: string;
  requestorEmailId: string;
  fileFormat: string;
  countryCode: string = 'US';
}
